import * as React from 'react';
import memoize from 'memoize-one';
import './Header.scss';
import CategoriesDropdown from '../CategoriesDropdown';
import MobileMenu from '../MobileMenu';
import SearchBar from '../SearchBar';
import MSRPToggle from '../MSRPToggle';
import LocationsButton from '../LocationsButton';
import { RouteComponentProps } from 'react-router';
import miles from 'src/assets/milesHeaderEn';
import {
  isMobile,
  isMobilelandscape,
  isMobileONLY
} from '../../utils/responsiveHelpers';
import { IResetSearchBar } from '../SearchBar/SearchBar';
import i18n from 'src/translation/i18n';
import { env } from 'src/shared/env';
import milesmobile from 'src/assets/miles';
import milesFr from 'src/assets/milesHeaderFR';
import getMilesdesktop from 'src/assets/getMilesdesktop';
import milesBannerFr from 'src/assets/milesBannerFr';
import { ifLoggedIn } from 'src/utils/navigation';

interface IHeaderProps extends RouteComponentProps {
  handleOnSubmitSearch(searchText: string): void;
  handleOnSearchSelectedPart(searchText: string): void;
  handleOnSearchSelectedModel(name: string, manufacturer: string): void;
  shouldShowSearchDropdown?: boolean;
  scrolled: boolean;
  content: any;
}

export class Header extends React.Component<IHeaderProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isMobile: isMobile(),
      resetSearchbar: { update: false, value: false },
      actualUrl: '',
      scrolled: false
    };
  }

  public componentDidMount() {
    // const resetValue = this.localUri(this.props.location);
    const update = !this.state.resetSearchbar.update;

    this.setState({
      actualUrl: this.props.location,
      resetSearchbar: { update, value: true },
      showSarchbar: false
    });
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    window.addEventListener('scroll', this.handlescroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    window.removeEventListener('scroll', this.handlescroll);
  }

  public handlescroll = () => {
    const isTop = window.scrollY < 50;
    if (isTop !== true) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };

  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.actualUrl !== this.props.location) {
      const update = !this.state.resetSearchbar.update;
      // const resetValue = this.localUri(this.props.location);
      this.setState({
        resetSearchbar: { update, value: true },
        actualUrl: this.props.location,
        showSarchbar: this.props.content ? true : false
      });
    }
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public setResetSearchbar = (value: IResetSearchBar) => {
    this.setState({ resetSearchbar: value });
  };

  // public localUri: any = memoize((location: any) => {
  //   if (location && location.pathname) {
  //     if (location.pathname.includes("search")) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  //   return true;
  // });

  public render() {
    return (
      <React.Fragment>
        {/* {this.state.isMobile && env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
          <div className="rpdevdummy-title">
            <a
              // href="/us/"
              href={
                env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? `https://www.reliableparts.ca/airmiles/`
                  : 'https://www.reliableparts.ca/airmiles/'
              }
              className="rp-logo rp-temp-mobile-logo"
              target="_blank"
            >
              <img
                src={i18n.language === 'en-CA' ? milesmobile : milesBannerFr}
                alt="airmiles"
              />
            </a>
          </div>
        ) : (
          ''
        )} */}
        <div
          className={
            this.state.scrolled
              ? 'rp-searchbar-header header-scrolled'
              : 'rp-searchbar-header'
          }
        >
          <div className="container-fluid rp-searchbar-header--container">
            <div className="row no-gutters">
              <div className="col-12 col-md-12 rp-searchbar-header--menu-container">
                {this.state.isMobile ? <MobileMenu /> : <CategoriesDropdown />}
              </div>
              <div className="col-12 align-self-center">
                {this.state.isMobile && (
                  <SearchBar aria-label={"Submit your search"}
                    resetSearchbar={this.state.resetSearchbar}
                    setResetSearchbar={this.setResetSearchbar}
                    location={this.props.history.location}
                    handleOnSubmitSearch={this.props.handleOnSubmitSearch}
                    handleOnSelectedPart={this.props.handleOnSearchSelectedPart}
                    handleOnSelectedModel={
                      this.props.handleOnSearchSelectedModel
                    }
                    shouldShowItems={this.props.shouldShowSearchDropdown}
                    placeholder={i18n.t('common.searchByPartModelKeyword')}
                  />
                )}
              </div>

              {/* {!this.state.isMobile && (
              <div className="col-3 col-md-5 col-lg-3 align-self-center">
                <div className="row no-gutters">
                  <div className="col-6">
                    <LocationsButton />
                  </div>
                  <div className="col-6">
                    <MSRPToggle />
                  </div>
                </div>
              </div>
            )} */}
            </div>
          </div>
        </div>
        {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
          <div className="rp-temp-header" ><strong>Get AIR MILES® Reward Miles at Reliable Parts – <a
          target="_blank"
          href="https://www.reliableparts.ca/airmiles">REGISTER NOW</a></strong>
            
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}

export default Header;
